import React, { useEffect, useState, useRef, Fragment } from 'react'
import {
    UploadOutlined
} from '@ant-design/icons'
import {
    Button,
    Input,
    Select,
    Spin,
    Form,
    Popover,
    Upload,
    Alert, message,
    Radio,
} from 'antd'
import './detail.less'
import '@/static/style/basetable.less'
import _, { fromPairs, get, set } from 'lodash'
import '@ant-design/pro-table/dist/table.css'
import { fetchTempApi, fetchInvoices, createInvoiceMatch, fetchExpressCompany, fetchDetail, } from './api'
import { fetchEnums } from '../common/api'
import { getAccountColumns, getColumns } from './config'
import { TablePipeline, BaseTable } from 'ali-react-table'
import { getFormatDateIsNull, transferx0ToX0 } from '../common/utils'
import { getAdminId, outputMoney, getSid, objToArr, getParmUrl,tokenConfig } from '@/public/utils'
import MutileEnterModal from './components/mutipleEnterModal'
import SelectDrawer from './components/selectDrawer'
import { StatusColorMap } from '../list/config'
import common from "@/public/common";
import { ajaxApi } from '@/server/index'

const FormItem = Form.Item
const { TextArea } = Input
const layout = {
    labelCol: { span: 2 },
    // wrapperCol: { span: 23 }
}
var upload = ['31', '08']
const MatchDetail = () => {
    const [form] = Form.useForm()
    const detail = useState({
        match_source: '02',
        adjust_amount: 0,
    })
    const [enums, setEnums] = useState({})
    const [type, setType] = useState('01')
    const [open, setOpen] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [data, setData] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [bills, setBills] = useState([])
    const [invoiceno, setInvoiceno] = useState('')
    const [accountList, setAccountList] = useState([])
    const [pipelineState, setPipelineState] = useState({})
    const [accountPipelineState, setAccountPipelineState] = useState({})
    const [expressCompany, setExpressCompany] = useState([])
    const [disabled, setDisabled] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false)
    const [fileList, setFileList] = useState([])




    const queryTemp = async () => {
        try {
            const tmp_code = getParmUrl('tempid')
            const { data } = await fetchTempApi({ tmp_code })
            setAccountList(get(data, 'data'))
        } catch (err) {
            console.log(err)
        }
    }

    const queryDetail = async () => {
        try {
            const match_id = getParmUrl('match_id')
            const { data } = await fetchDetail({ match_id })
            var result = get(data, 'data') || {}
            var type = get(result, 'org_invoice_list[0].invoice_type')
            setAccountList(get(result, 'org_account_list') || [])
            setBills(get(result, 'org_invoice_list') || [])
            setData(result)
            setType(type)
            setDisabled(!['04', '00'].includes(get(result, 'status')))
            if (['04', '01'].includes(type)) {
                form && form.setFieldsValue({
                    back_company_id: get(result, 'back_company_id'),
                    back_send_code: get(result, 'back_send_code'),
                    remark: get(result, 'remark'),
                })
            }
            if(upload.includes(type)){
                var fileList = get(result,'invoice_file_list').map(item => {
                    var { org_name, file_name } = item
                    return { name: org_name, url: file_name, status: 'done',...item }
                  })
                  form && form.setFieldsValue({ invoice_file_list: fileList })
                  setFileList(fileList)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const getBlueLine = () => {
        return <span style={{ overflow: 'hidden', position: "relative", marginRight: '12px' }}><span className='blueLine'></span></span>
    }

    const getenums = async () => {
        try {
            const {
                data = {}
            } = (await fetchEnums()) || {}
            setEnums(transferx0ToX0(data))
        } catch (err) {
            console.log(err)
        }
    }

    const getExpressCompany = async () => {
        try {
            const {
                data = []
            } = (await fetchExpressCompany()) || {}
            var newExpress = (data || []).map(item => {
                var { code, name } = item
                return { value: code, label: name }
            })
            setExpressCompany(newExpress)
        } catch (err) {
            console.log(err)
        }
    }

    const searchBillByCode = async () => {
        if (!invoiceno) {
            message.error('请输入发票号码')
        }
        var bysystemArr = _.keys(get(enums, '发票类型枚举值(系统)'))
        const query = {
            sid: getSid(),
            invoice_source: bysystemArr.includes(type) ? "00" : "02",
            invoice_no_list: [invoiceno],
            is_all: true,
            invoice_type: type
        }
        try {
            let { data } = (await fetchInvoices({ query })) || {}
            var all_invoice_list = get(data, 'data.list')
            if (!get(all_invoice_list, 'length')) {
                message.error("未找到相关发票！")
                return
            } else {
                var occupy_list = _.filter(all_invoice_list, ['is_occupy', true])
                if (get(occupy_list, 'length')) {
                    var row = occupy_list[0]
                    var occupy_code_str = get(row.match_id_list, 'length') > 1 ? get(row, 'match_id_list').join(',') : (get(row, 'match_id_list[0]') || '')
                    message.error(`发票（发票号码：${invoiceno}）被${occupy_code_str}占用!`, 3)
                    return
                } else {
                    concatBills(all_invoice_list)
                    setOpen(false)
                    setInvoiceno('')
                }
            }
        } catch (err) {
            console.log(err)
        }
    }

    const concatBills = (data) => {
        var newBills = _.uniqBy((_.differenceBy(bills, data, 'invoice_id')).concat(data), 'invoice_id')
        setBills(newBills)
    }

    useEffect(() => {
        getenums()
        getExpressCompany()
        if (getParmUrl('tempid')) {
            queryTemp()
        }
        if (getParmUrl('match_id')) {
            queryDetail()
        }
    }, [])

    const getSelectBtn = () => {
        var single_enter = ['01', '185', '04', 'X0', '10','08xdp','08xdpp','008','010'].concat(upload)
        var mutiple_enter = ['01', '185','08xdp','08xdpp','008','010'].concat(upload)
        var mutiple_select = ['01', '185', '04', 'X0', '10','08xdp','08xdpp','008','010'].concat(upload)
        if (disabled) { return <div className='mt20'></div> }
        return (
            <div className='mt20 mb20'>
                {
                    single_enter.includes(type) &&
                    <Popover
                        content={<div>
                            <span style={{ color: 'red' }}>*</span>发票号码：
                            <Input
                                style={{ width: 150 }}
                                placeholder="请输入"
                                value={invoiceno || undefined}
                                name='invoiceno'
                                onChange={(e) => { setInvoiceno(e.target.value.trim()) }}
                            />
                            <div className='mt12' style={{ textAlign: "right" }}>
                                <Button
                                    shape="round"
                                    size="small"
                                    onClick={() => { setOpen(false) }}
                                >取消</Button>
                                <Button
                                    type='primary'
                                    shape="round"
                                    className='ml12'
                                    size="small"
                                    onClick={searchBillByCode}
                                >确定</Button>
                            </div>

                        </div>}
                        title="输入单张发票"
                        trigger="click"
                        visible={open}
                        type='round'
                        overlayClassName='changeStyle'
                        onVisibleChange={() => { setOpen(!open) }}
                    >
                        <Button
                            type='primary'
                            shape="round"
                            disabled={disabled}
                            onClick={() => { setOpen(!open) }}
                        >输入单张发票</Button>
                    </Popover>
                }
                {
                    mutiple_enter.includes(type) &&
                    <Button
                        className='ml12'
                        shape="round"
                        disabled={disabled}
                        onClick={() => { setModalOpen(true) }}
                    >输入连续多张发票</Button>
                }
                {
                    mutiple_select.includes(type) &&
                    <Button
                        className='ml12'
                        shape="round"
                        disabled={disabled}
                        onClick={() => { setDrawerOpen(true) }}
                    >根据发票清单选择</Button>
                }
                {/* {
                    upload.includes(type) &&
                    <span>
                        <Button
                            className='ml12'
                            type='primary'
                            shape="round"
                            disabled={disabled}
                            onClick={() => { setDrawerOpen(true) }}
                        >上传发票</Button>
                        <span className='greyFont ml12'>仅支持上传PDF、OFD格式的文件，最大支持单次上传30张发票进行解析，提交审核时单次量最大支持120张发票</span>
                    </span>
                } */}

            </div>
        )
    }

    const getPipeline = () => {
        const pipeline = new TablePipeline({
            state: pipelineState,
            setState: (updater) => {
                // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
                // updater 接受原来的 pipelineState，返回新的 pipelineState
                setPipelineState((prev) => { updater(prev.pipelineState) })
            },
        })

        pipeline.input({
            dataSource: bills,
            columns: getColumns({ enums, updateFun: setBills, bills, type, showStatus: 1, disabled })
        })
        pipeline.primaryKey('invoice_id')
        return pipeline
    }

    const getAccountPipeline = () => {
        const pipeline = new TablePipeline({
            state: accountPipelineState,
            setState: (updater) => {
                // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
                // updater 接受原来的 pipelineState，返回新的 pipelineState
                setAccountPipelineState((prev) => { updater(prev.pipelineState) })
            },
        })

        pipeline.input({
            dataSource: accountList,
            columns: getAccountColumns()
        })
        pipeline.primaryKey('supplier_account_code')
        return pipeline
    }

    const summaryMoney = (list, notNeedform) => {
        var money = _.reduce((list || []).map(item => item.match_invoice_amount), function (sum, n) {
            return sum + n;
        }, 0)
        return notNeedform ? (money || 0) : outputMoney(money || 0)
    }

    const getNumDiff = () => {
        var num = 0
        var account_amount = summaryMoney(accountList, true)
        var bill_amount = summaryMoney(bills, true)
        num = account_amount - bill_amount
        return num
    }

    const saveTemp = () => {
        if (!get(bills, 'length')) {
            message.error('请选择发票')
            return
        }
        //check diff?!=0
        if (Math.abs(getNumDiff()) > 1) {
            message.error('税票差异大于1,不能保存为草稿')
            return
        }
        form.validateFields().then(values => {
            setSubmitLoading(true)
            updateOrCreateFun('00')
        }).catch(err => {
        })
    }

    const submit = () => {
        if (!get(bills, 'length')) {
            message.error('请选择发票')
            return
        }
        //check diff?!=0
        if (Math.abs(getNumDiff()) > 1) {
            message.error('税票差异大于1,不能提交视客审核')
            return
        }
        //check from-validateFields
        if (['10', '01'].includes(type)) {
            form.validateFields().then(values => {
                setSubmitLoading(true)
                updateOrCreateFun('01')
            }).catch(err => {
                console.log(err)
                if (get(err, 'errorFields.length')) {
                    return
                }
            })
        } else {
            setSubmitLoading(true)
            updateOrCreateFun('01')
        }
    }

    const updateOrCreateFun = async (status) => {
        var account_list = get(data, 'org_account_list') || accountList
        const values = await form.validateFields()
        var { back_company_id } = (values || {})
        var back_company_name = back_company_id ? get(_.find(expressCompany, ['value', back_company_id]), 'label') : ""
        var params = {
            ...data,
            ...values,
            back_company_name,
            match_id: get(data, 'match_id') || null,
            sid: getSid(),
            adjust_amount: getNumDiff(),
            status,
            adder_id: getAdminId(),
            account_list: account_list.map(item => {
                var { match_invoice_amount } = item
                return { ...item, invoice_amount: match_invoice_amount }
            }),
            buyer_no: get(data, 'buyer_no') || get(account_list, '[0].buyer_no'),
            buyer_name: get(data, 'buyer_name') || get(account_list, '[0].buyer_name'),
            invoice_list: bills.map(item => {
                var { invoice_id, match_invoice_amount } = item
                return { invoice_id, match_invoice_amount }
            }),
        }
        delete params.org_account_list
        delete params.org_invoice_list
        updateOrCreateAixos(params)
    }

    const updateOrCreateAixos = _.throttle(async (params) => {
        try {
            let res = (await createInvoiceMatch(params)) || {}
            setSubmitLoading(false)
            if (get(res, 'data.data')) {
                message.success("提交成功")
                setTimeout(() => {
                    if (!get(data, 'match_id')) {
                        window.location.replace(window.location.origin + "/main/bill/match/detail?match_id=" + get(res, 'data.data'))
                    } else {
                        window.location.reload()
                    }
                }, 2000);
            } else if(get(res,"data.message")) {
                message.error(res.data.message)
            }
        } catch (err) {
            console.log(err)
            setSubmitLoading(false)
        }
    }, 1000)

    const returnDiffHtml = () => {
        return (
            <section className='ml20'>
                <div>
                    <span className='part'>对账单</span>
                    <span className='symbol'></span>
                    <span className='part'>发票</span>
                    <span className='symbol'></span>
                    <span className='part'>差异</span>
                </div>
                <div className='result'>
                    <span className='part'></span>
                    <span className='symbol'>-</span>
                    <span className='part'></span>
                    <span className='symbol'>=</span>
                    <span className='part'></span>
                </div>
                <div className='result'>
                    <span className='part'>{summaryMoney(accountList)}</span>
                    <span className='symbol'></span>
                    <span className='part'>{summaryMoney(bills)}</span>
                    <span className='symbol'></span>
                    <span className={'part' + (getNumDiff() != 0 ? ' redFont' : '')}>{outputMoney(getNumDiff())}</span>
                </div>
            </section>
        )
    }

    const getUrl = async (file_name) => {
        try {
            let formData = new FormData();
            formData.append("file_name", file_name);
            let res = await ajaxApi({
                url: common.SapUrl + "invoice/fims/file/download",
                params: formData,
              })
            console.log(res,file_name)
            return get(res.data.data, '0')
        } catch (err) { console.log(err); return null }
    }

    const changeUpload = (file, types) => {
        try {
            if (file.file.status === "done") {
                let newUrl = file.fileList.map((item) => {
                    let url;
                    if (get(item,'response.data')) {
                        url = get(item,'response.data');
                    } else {
                        url = item.url;
                    }
                    return { org_name: get(item, 'name'), file_name: url, ...item, url: url, name: url };
                });
                data.invoice_file_list = newUrl;
                form.setFieldsValue({ invoice_file_list: newUrl })
                setFileList(newUrl)
                setData(data)
            }
            setFileList(file.fileList)
        } catch (err) { console.log(err) }
    }

    const getProps = () => {
        return {
            action: common.SapUrl + "invoice/fims/file/upload",
            headers: {
                authorization: "authorization-text",...tokenConfig,
            },
            multiple: true,
            maxCount: 10,
            fileList: fileList,
            onPreview: async (file) => {
                var url = get(file, 'url') || get(file, 'response.data')
                console.log(url,'url')
                if (url) {
                    var download_url = await getUrl(url)
                    if (download_url) {
                        window.open(download_url)
                    }
                }

            }
        }
    }


    return (
        <div className={'matchDetail'}>
            {
                get(data, 'match_id') ?
                    <section className='checkInfo'>
                        <div className='roundBorder'>
                            {getBlueLine()}
                            <span className='bold'>匹配单信息</span>
                            <span className='ml4' style={{ color: StatusColorMap[get(data, 'status')] }}>{get(enums, '匹配单状态枚举值') && get(enums, '匹配单状态枚举值')[get(data, 'status')]}</span>
                            <div className='summary flex_summary'>
                                <span className='mr16'>票单关联号：{get(data, 'match_id') || '-'}</span>
                                <span className='mr16'>结算主体：{get(data, 'buyer_name') || "-"}</span>
                                <span className='mr16'>创建时间：{getFormatDateIsNull(get(data, 'create_time'), 'YYYY-MM-DD hh:mm:ss')}</span>
                                <span className='mr16'>最后修改时间：{getFormatDateIsNull(get(data, 'update_time'), 'YYYY-MM-DD hh:mm:ss')}</span>
                            </div>
                        </div>
                        <div className='roundBorder  BaseTable boldHeader'>
                            <p className='mb20 bold'>{getBlueLine()}已选对账单</p>
                            <Alert message={<div>已选账单：
                                <span className='ml4 mr24 blueFont'>{get(accountList, 'length') || 0}</span>
                                合计本次匹配金额：￥
                                <span className='ml4 mr4 blueFont'>
                                    {
                                        outputMoney(
                                            _.reduce((accountList || []).map(item => item.match_invoice_amount), function (sum, n) {
                                                return sum + n;
                                            }, 0))
                                    }
                                </span>
                            </div>
                            }
                                type="info" showIcon />
                            <BaseTable
                                className='antd_table_style mt24'
                                useOuterBorder
                                style={{ maxHeight: 700, overflow: 'auto', '--cell-border': 'none' }}
                                {...(getAccountPipeline() && getAccountPipeline().getProps())}
                            />
                        </div>
                    </section>
                    : <section className='checkInfo roundBorder'>
                        <div className='left'>
                            <div className="title">
                                {getBlueLine()}
                                <span className='bold'>重要信息核对</span>
                            </div>
                            <div className='ml10 checkInfo_content'>
                                <p>1、一般纳税人需开具专票，小规模纳税人可以找税局开专票</p>
                                <p>2、发票中的购买方信息非实际邮寄地址，请勿邮寄错误</p>
                                <p>3、邮寄哪一联：纸质<span className='orangeFont'>专票</span>，邮寄【<span className='orangeFont'>发票联+折扣联</span>】</p>
                                <p style={{ marginLeft: 105 }}>纸质<span className='purpleFont'>普票</span>，邮寄【<span className='purpleFont'>发票联</span>】（每一联必须加盖发票专用章）</p>
                            </div>
                        </div>
                        <div className='right'>
                            <div className="title">
                                {getBlueLine()}
                                <span className='bold'>发票邮寄地址</span>
                            </div>
                            <div className='ml10 checkInfo_content'>
                                <p>收件地址:南京市秦淮区光华路石门坎104号8号楼（视客眼镜网财务部）</p>
                                <p>收件人：刘芬</p>
                                <p>收件人电话：15951857145</p>
                            </div>
                        </div>
                    </section>
            }

            <section className='roundBorder second BaseTable boldHeader'>
                <div className='mb16'>{getBlueLine()}
                    <span className='bold'>选择发票</span>
                </div>
                <Radio.Group
                    disabled={disabled}
                    onChange={(e) => { setType(e.target.value); setBills([]) }}
                    value={type}
                    options={objToArr(get(enums, '发票类型枚举值(采购)'))}
                >
                </Radio.Group>
                {getSelectBtn()}


                <BaseTable
                    className='antd_table_style'
                    useOuterBorder
                    style={{ maxHeight: 700, overflow: 'auto', '--cell-border': 'none' }}
                    {...(getPipeline() && getPipeline().getProps())}
                />
                <div className='summary'>
                    累计匹配<span className={get(bills, 'length') && 'redFont'}> {get(bills, 'length') || 0} </span>
                    <span>
                        张发票，发票本次匹配金额合计：￥
                        <span className={get(bills, 'length') && 'redFont'}>
                            {summaryMoney(bills)}
                        </span>
                    </span>
                </div>
            </section>
            <section className='roundBorder second'>
                <p>{getBlueLine()}
                    <span className='bold'>税票差异调整 </span><span style={{ color: 'orange', fontSize: 12, fontWeight: 400 }}>（允许差异在1元以内）</span></p>
                {returnDiffHtml()}
            </section>
            {
                ['185', '04', '01'].includes(type) &&
                <section className='roundBorder second'>
                    <p className='bold'>{getBlueLine()}
                        录入快递信息</p>
                    <Form form={form} {...layout}>
                        <FormItem name="back_company_id" label='快递公司' initialValue={undefined} rules={[{ required: true }]}>
                            <Select
                                placeholder="请选择"
                                disabled={disabled}
                                style={{ width: 200 }}
                                allowClear
                                options={expressCompany}
                                optionFilterProp={'label'}
                            />
                        </FormItem>
                        <FormItem name="back_send_code" label='快递单号' rules={[{ required: true }]}>
                            <Input placeholder="请输入" allowClear initialValue={''} style={{ width: 200 }} disabled={disabled} />
                        </FormItem>
                        <FormItem name="remark" label='备注'>
                            <TextArea rows={2} placeholder="请输入" maxLength={200} initialValue={''} style={{ width: 500 }} disabled={disabled} />
                        </FormItem>
                    </Form>
                </section>
            }
            {
                upload.includes(type) &&
                <section className='roundBorder second'>
                    <p className='bold'>{getBlueLine()}
                        上传发票附件</p>
                    <Form form={form} {...layout}>
                        <FormItem label='附件' rules={[{ required: true }]} name='invoice_file_list'>
                            <Upload
                                disabled={disabled}
                                {...getProps()}
                                onChange={(file) => changeUpload(file)}
                            >
                                <Button icon={<UploadOutlined />} disabled={disabled}>上传文件</Button>
                            </Upload>
                            <div className="mt12 greyFont">支持拓展名：.rar,.zip,.pdf,.jpg...</div>
                        </FormItem>
                    </Form>
                </section>
            }

            <div className='stickBottom'>
                <section className='roundBorder tar' >
                    <Spin spinning={submitLoading}>
                        <Button
                            className='ml12'
                            shape="round"
                            onClick={() => { window.history.go(-1) }}
                        >取消</Button>
                        {
                            (['00', '04'].includes(get(data, 'status'))
                                || !get(data, 'status')
                            ) &&
                            <span >
                                <Button
                                    className='ml12'
                                    shape="round"
                                    onClick={saveTemp}
                                >保存为草稿</Button>
                                <Button
                                    className='ml12'
                                    shape="round"
                                    type='primary'
                                    onClick={submit}
                                >提交视客审核</Button>
                            </span>
                        }
                    </Spin>
                </section>
            </div>


            {
                modalOpen &&
                <MutileEnterModal
                    setOpen={(open) => { setModalOpen(open) }}
                    setBill={(bills) => { concatBills(bills) }}
                    type={type}
                    enums={enums}
                />
            }

            {
                drawerOpen &&
                <SelectDrawer
                    setOpen={(open) => { setDrawerOpen(open) }}
                    setBill={(bills) => { setBills(bills) }}
                    enums={enums}
                    bills={bills}
                    type={type}
                />
            }

        </div>
    )

}

export default MatchDetail


// WEBPACK FOOTER //
// ./src/pages/billVerification/match/detail/detail.js